import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

class RepresentantesApi extends CrudBase {

  getBI = (codigo) => axios.get(`${this.endpoint}/${codigo}/bi`)

  findByText = (text, cnpj) => axios.get(`${this.endpoint}?text=${text}&cnpj=${cnpj}`)
  listSupervisores = (text) => axios.get(`${this.endpoint}/supervisores?text=${text}`);

  defaultMethods = {
    ...this.defaultMethods,
    findByText: this.findByText,
    getBI: this.getBI,
    listSupervisores: this.listSupervisores
  }
}

const representantes = new RepresentantesApi('api/comercial/representantes');

export default representantes.defaultMethods;

